// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1498":"408ab064","7241":"7e1766d8","8247":"cd95250e","8784":"408ab064","8927":"2ddcc344"}[chunkId] + ".chunk.css";
};